import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const FlexOfficeSignInReader = (props) => <AuthPageReader {...props} domainType="FLEX_OFFICE" pageKey="signIn" />;

export default FlexOfficeSignInReader;
